/* Ropo Garden — Ecopots-brändisivun vuorovaikutus (portattu ecopotskauppa.comin ecopots-signature.js:stä).
   Reveal-animaatiot, laskurit, hero-video ja -koreografia. Kaikki prefers-reduced-motion-suojattu. */
(function () {
  'use strict';
  if (window.rgEcoInit) return;
  window.rgEcoInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var heroVideo = document.querySelector('.eco-hero__video');
  if (heroVideo) {
    var conn = navigator.connection || {};
    if (conn.saveData || reduce) {
      heroVideo.removeAttribute('autoplay');
    } else {
      var startVideo = function () {
        var go = function () {
          // data-eco-sources = "korkeus|url;korkeus|url;…" — valitaan näytön leveyteen sopiva mp4
          var list = (heroVideo.getAttribute('data-eco-sources') || '').split(';').map(function (s) {
            var parts = s.split('|'); return { h: parseInt(parts[0], 10) || 0, u: parts[1] || '' };
          }).filter(function (x) { return x.u; }).sort(function (a, b) { return a.h - b.h; });
          var want = window.matchMedia('(max-width: 749px)').matches ? 480 : window.matchMedia('(max-width: 1249px)').matches ? 720 : 1080;
          var pick = null;
          list.forEach(function (x) { if (!pick || x.h <= want || pick.h < want) pick = x; });
          if (pick && !heroVideo.getAttribute('src')) {
            // Liquid tarjoaa vain parhaan mp4:n → johdetaan Shopifyn 720p/480p-versio nimikaavasta, virheessä alkuperäinen
            var label = want <= 480 ? 'SD-480p-1.5Mbps' : want <= 720 ? 'HD-720p-4.5Mbps' : null;
            var u = pick.u, derived = (label && pick.h > want) ? u.replace(/\.(HD|SD)-\d+p-[\d.]+Mbps-/, '.' + label + '-') : u;
            if (derived !== u) heroVideo.addEventListener('error', function () { if (heroVideo.src !== u) { heroVideo.src = u; heroVideo.load(); heroVideo.play().catch(function () {}); } }, { once: true });
            heroVideo.src = derived; heroVideo.load();
          }
          heroVideo.play().catch(function () {});
        };
        if ('requestIdleCallback' in window) { window.requestIdleCallback(go, { timeout: 2500 }); } else { setTimeout(go, 600); }
      };
      if (document.readyState === 'complete') { startVideo(); } else { window.addEventListener('load', startVideo, { once: true }); }
    }
    var markReady = function () { heroVideo.classList.add('eco-hero__video--ready'); };
    if (heroVideo.readyState >= 2) { markReady(); } else { heroVideo.addEventListener('loadeddata', markReady, { once: true }); }
  }

  var heroContent = document.querySelector('.eco-hero__content');
  if (heroContent) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { heroContent.classList.add('eco-in'); });
    });
  }

  document.querySelectorAll('[data-eco-hero-scroll]').forEach(function (cue) {
    cue.addEventListener('click', function () {
      var hero = cue.closest('.shopify-section') || document.querySelector('.eco-hero');
      var target = hero ? hero.nextElementSibling : null;
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
    });
  });

  var heroMediaEl = document.querySelector('.eco-hero__media');
  var heroRootEl = document.querySelector('.eco-hero');
  if (heroMediaEl && heroRootEl && !reduce) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY, h = heroRootEl.offsetHeight || 1;
        if (y <= h) heroMediaEl.style.transform = 'translateY(' + (y * 0.28).toFixed(1) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  var revealTargets = document.querySelectorAll('.eco-reveal, .eco-material, .eco-colors');
  if (!('IntersectionObserver' in window) || reduce) {
    revealTargets.forEach(function (el) { el.classList.add('eco-in'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('eco-in'); revealObserver.unobserve(entry.target); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    revealTargets.forEach(function (el, i) {
      el.style.setProperty('--eco-delay', (i % 6) * 70 + 'ms');
      revealObserver.observe(el);
    });
  }

  document.querySelectorAll('[data-eco-bottle]').forEach(function (el, i) { el.style.setProperty('--i', i); });

  var counters = document.querySelectorAll('[data-eco-count]');
  if (counters.length) {
    var runCounter = function (el) {
      var target = parseFloat(el.getAttribute('data-eco-count'));
      var decimals = parseInt(el.getAttribute('data-eco-decimals') || '0', 10);
      if (reduce || !('requestAnimationFrame' in window)) { el.textContent = target.toFixed(decimals); return; }
      var duration = 1400, start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var counterObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { runCounter(entry.target); counterObserver.unobserve(entry.target); }
        });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { counterObserver.observe(el); });
    } else {
      counters.forEach(runCounter);
    }
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduce) {
    document.querySelectorAll('.eco-cat').forEach(function (card) {
      var glare = document.createElement('span');
      glare.className = 'eco-cat__glare'; glare.setAttribute('aria-hidden', 'true'); card.appendChild(glare);
      var raf = null;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function () {
          card.style.transform = 'perspective(90rem) rotateX(' + (py * -7).toFixed(2) + 'deg) rotateY(' + (px * 9).toFixed(2) + 'deg) translateY(-4px)';
          glare.style.opacity = '1';
          glare.style.transform = 'translate(' + (px * 60).toFixed(1) + '%, ' + (py * 60).toFixed(1) + '%)';
        });
      });
      card.addEventListener('mouseleave', function () {
        if (raf) window.cancelAnimationFrame(raf);
        card.style.transform = ''; glare.style.opacity = '0';
      });
    });
  }

  // ---- Mallihakija: haku + koko-/värisuodatus ----
  var finder = document.querySelector('[data-eco-models]');
  if (finder) {
    var cards = Array.prototype.slice.call(finder.querySelectorAll('[data-eco-model]'));
    var input = finder.querySelector('[data-eco-search]');
    var pills = Array.prototype.slice.call(finder.querySelectorAll('[data-eco-filter]'));
    var resetBtn = finder.querySelector('[data-eco-reset]');
    var countEl = finder.querySelector('[data-eco-count]');
    var emptyEl = finder.querySelector('[data-eco-empty]');
    var state = { q: '', size: '', color: '' };
    var norm = function (s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
    var apply = function () {
      var shown = 0;
      cards.forEach(function (card) {
        var name = card.getAttribute('data-name') || '';
        var subs = Array.prototype.map.call(card.querySelectorAll('[data-sub]'), function (a) { return a.getAttribute('data-sub') || ''; }).join(' ');
        var colors = (card.getAttribute('data-colors') || '').split(' ');
        var sizes = (card.getAttribute('data-sizes') || '').split(' ');
        var ok = true;
        if (state.q && (name + ' ' + subs).indexOf(state.q) === -1) ok = false;
        if (ok && state.size && sizes.indexOf(state.size) === -1) ok = false;
        if (ok && state.color && colors.indexOf(state.color) === -1) ok = false;
        card.hidden = !ok;
        if (ok) shown++;
      });
      var active = !!(state.q || state.size || state.color);
      if (resetBtn) resetBtn.hidden = !active;
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (countEl) countEl.textContent = active ? shown + ' / ' + cards.length : '';
      if (active) {
        var hash = [];
        if (state.size) hash.push('koko=' + state.size);
        if (state.color) hash.push('vari=' + state.color);
        if (hash.length && window.history && window.history.replaceState) window.history.replaceState(null, '', '#rg-mallit?' + hash.join('&'));
      }
    };
    pills.forEach(function (pill) {
      pill.setAttribute('aria-pressed', 'false');
      pill.addEventListener('click', function () {
        var kind = pill.getAttribute('data-eco-filter'), val = pill.getAttribute('data-value');
        var isOn = state[kind] === val;
        state[kind] = isOn ? '' : val;
        pills.forEach(function (p) { if (p.getAttribute('data-eco-filter') === kind) p.setAttribute('aria-pressed', (!isOn && p === pill) ? 'true' : 'false'); });
        apply();
      });
    });
    if (input) {
      var t = null;
      input.addEventListener('input', function () {
        if (t) window.clearTimeout(t);
        t = window.setTimeout(function () { state.q = norm(input.value); apply(); }, 120);
      });
    }
    if (resetBtn) resetBtn.addEventListener('click', function () {
      state = { q: '', size: '', color: '' };
      if (input) input.value = '';
      pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
      apply();
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', window.location.pathname);
    });
    // Esivalinta URL:sta: #rg-mallit?koko=iso&vari=terracotta
    var m = /#rg-mallit\?([^#]*)/.exec(window.location.href);
    if (m) {
      m[1].split('&').forEach(function (kv) {
        var p = kv.split('='); var k = p[0] === 'koko' ? 'size' : p[0] === 'vari' ? 'color' : null;
        if (k && p[1]) {
          state[k] = decodeURIComponent(p[1]);
          pills.forEach(function (pl) { if (pl.getAttribute('data-eco-filter') === k && pl.getAttribute('data-value') === state[k]) pl.setAttribute('aria-pressed', 'true'); });
        }
      });
      apply();
    }
  }

  // ---- Tuotesivu: pikkukuvat 6 + "+N kuvaa", kuvauksen rajaus "Näytä lisää" ----
  var thumbList = document.querySelector('.thumbnail-list');
  if (thumbList && window.matchMedia('(min-width: 750px)').matches) {
    var thumbs = thumbList.querySelectorAll('.thumbnail-list__item');
    if (thumbs.length > 7) {
      var hiddenThumbs = [];
      thumbs.forEach(function (t, i) { if (i >= 6) { t.classList.add('eco-thumb-hidden'); hiddenThumbs.push(t); } });
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button'; moreBtn.className = 'eco-thumb-more'; moreBtn.textContent = '+' + hiddenThumbs.length + ' kuvaa';
      moreBtn.addEventListener('click', function () { hiddenThumbs.forEach(function (t) { t.classList.remove('eco-thumb-hidden'); }); moreBtn.remove(); });
      thumbList.parentNode.insertBefore(moreBtn, thumbList.nextSibling);
    }
  }
  var productDesc = document.querySelector('.product__description');
  if (productDesc && productDesc.scrollHeight > 420) {
    productDesc.classList.add('eco-desc-clamp');
    var descToggle = document.createElement('button');
    descToggle.type = 'button'; descToggle.className = 'eco-desc-toggle'; descToggle.textContent = 'Näytä lisää'; descToggle.setAttribute('aria-expanded', 'false');
    productDesc.insertAdjacentElement('afterend', descToggle);
    descToggle.addEventListener('click', function () {
      var clamped = productDesc.classList.toggle('eco-desc-clamp');
      descToggle.textContent = clamped ? 'Näytä lisää' : 'Näytä vähemmän'; descToggle.setAttribute('aria-expanded', clamped ? 'false' : 'true');
    });
  }

  // ---- UKK: haku, avaa/sulje kaikki, ryhmänavigoinnin aktiivitila, syvälinkit, linkin kopiointi ----
  var faq = document.querySelector('[data-eco-faq]');
  var faqRoot = faq ? faq.closest('.eco-faq') : null;
  if (faqRoot) {
    var items = Array.prototype.slice.call(faqRoot.querySelectorAll('[data-eco-faq-item]'));
    var groups = Array.prototype.slice.call(faqRoot.querySelectorAll('[data-eco-faq-group]'));
    var input = faqRoot.querySelector('[data-eco-faq-search]');
    var countEl = faqRoot.querySelector('[data-eco-faq-count]');
    var emptyEl = faqRoot.querySelector('[data-eco-faq-empty]');
    var navLinks = Array.prototype.slice.call(faqRoot.querySelectorAll('[data-eco-faq-nav] a'));
    var norm = function (s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); };
    items.forEach(function (it) { it.setAttribute('data-text', norm(it.textContent)); });
    var updateGroupCounts = function () {
      groups.forEach(function (g) {
        var visible = g.querySelectorAll('[data-eco-faq-item]:not([hidden])').length;
        var c = g.querySelector('[data-eco-faq-group-count]');
        if (c) c.textContent = visible + (visible === 1 ? ' kysymys' : ' kysymystä');
        g.hidden = visible === 0;
      });
    };
    var highlight = function (q) {
      items.forEach(function (it) {
        var t = it.querySelector('.eco-faq__qtext'); if (!t) return;
        var raw = t.getAttribute('data-raw') || t.textContent; t.setAttribute('data-raw', raw);
        if (!q) { t.textContent = raw; return; }
        var i = raw.toLowerCase().indexOf(q);
        if (i < 0) { t.textContent = raw; return; }
        t.innerHTML = ''; t.appendChild(document.createTextNode(raw.slice(0, i)));
        var m = document.createElement('mark'); m.textContent = raw.slice(i, i + q.length); t.appendChild(m);
        t.appendChild(document.createTextNode(raw.slice(i + q.length)));
      });
    };
    var applySearch = function () {
      var q = norm(input ? input.value : '');
      var shown = 0;
      items.forEach(function (it) {
        var ok = !q || it.getAttribute('data-text').indexOf(q) !== -1;
        it.hidden = !ok; if (ok) shown++;
        if (q && ok && shown <= 4) it.open = true;
      });
      highlight(q);
      updateGroupCounts();
      if (countEl) countEl.textContent = q ? (shown + ' / ' + items.length + ' kysymystä') : '';
      if (emptyEl) emptyEl.hidden = shown !== 0;
    };
    if (input) {
      var ft = null;
      input.addEventListener('input', function () { if (ft) window.clearTimeout(ft); ft = window.setTimeout(applySearch, 120); });
    }
    var openBtn = faqRoot.querySelector('[data-eco-faq-open]'), closeBtn = faqRoot.querySelector('[data-eco-faq-close]');
    if (openBtn) openBtn.addEventListener('click', function () { items.forEach(function (it) { if (!it.hidden) it.open = true; }); });
    if (closeBtn) closeBtn.addEventListener('click', function () { items.forEach(function (it) { it.open = false; }); });
    updateGroupCounts();
    // syvälinkki: #q-... avaa kysymyksen, #ryhmä vierittää ryhmään
    var openHash = function () {
      var h = decodeURIComponent(window.location.hash || '').slice(1);
      if (!h) return;
      var el = document.getElementById(h);
      if (el && el.matches('[data-eco-faq-item]')) {
        el.open = true; el.classList.add('eco-faq__item--flash');
        window.setTimeout(function () { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
        window.setTimeout(function () { el.classList.remove('eco-faq__item--flash'); }, 2500);
      }
    };
    openHash(); window.addEventListener('hashchange', openHash);
    // linkin kopiointi
    faqRoot.querySelectorAll('[data-eco-faq-copy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var url = window.location.origin + window.location.pathname + a.getAttribute('href');
        if (navigator.clipboard) { e.preventDefault(); navigator.clipboard.writeText(url).then(function () { var t = a.textContent; a.textContent = 'Linkki kopioitu'; window.setTimeout(function () { a.textContent = t; }, 1800); }); }
      });
    });
    // ryhmänavigoinnin aktiivitila vierityksen mukaan
    if (navLinks.length && 'IntersectionObserver' in window) {
      var setActive = function (id) { navLinks.forEach(function (l) { l.classList.toggle('eco-series__pill--active', l.getAttribute('data-target') === id); }); };
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) setActive(en.target.id); });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
      groups.forEach(function (g) { spy.observe(g); });
      navLinks.forEach(function (l) { l.addEventListener('click', function () { setActive(l.getAttribute('data-target')); }); });
    }
  }
})();
